import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getIdToken, determineLoggedInStatus, getRolesFromToken } from '@/utils/auth';
import getPageTitle from '@/utils/get-page-title';
import i18n from '@/i18n'; // internationalization
import Logging from '@/logging';
import cognito from '@/cognito';

// NProgress Configuration
NProgress.configure({ showSpinner: false });

// no redirect whitelist
const whiteList = ['404', '/login', '/auth-redirect', '/login/oauth2/code/cognito', '/cognito-login'];

router.beforeEach(async (to, from, next) => {
	// start progress bar
	NProgress.start();

	// set page title
	document.title = getPageTitle(to.meta.title);

	// determine whether the user has logged in
	const hasToken = determineLoggedInStatus();

	if (hasToken) {
		if (to.path === '/login') {
			// if is logged in, redirect to the home page
			next({ path: '/' });
			NProgress.done();
		} else {
			// determine whether the user has obtained his permission roles through getInfo
			const hasRoles = store.getters.roles && store.getters.roles.length > 0;

			if (hasRoles) {
				next();
			} else {
				try {
					// get roles
					// note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
					const roles = getRolesFromToken(getIdToken());

					// console.log('roles: ', roles);

					// generate accessible routes map based on roles
					const accessRoutes = await store.dispatch('permission/generateRoutes', roles);

					// dynamically add accessible routes
					router.addRoutes(accessRoutes);
					store.commit('user/SET_ROLES', roles);
					// hack method to ensure that addRoutes is complete
					// set the replace: true, so the navigation will not leave a history record
					next({ ...to, replace: true });
				} catch (error) {
					Logging.log(error);
					store.commit('user/SET_ROLES', []);
					Message.error(i18n.t('somethingWentWrong'));

					// TODO: redirect to an error page, line below causes infinite login loop
					cognito.logout();
					NProgress.done();
				}
			}
		}
	} else {
		/* has no token*/
		if (whiteList.indexOf(to.path) !== -1) {
			// in the free login whitelist, go directly
			next();
		} else {
			// other pages that do not have permission to access are redirected to the login page.
			if (process.env.VUE_APP_URL) {
				// window.location.href = `${process.env.VUE_APP_URL}/login`;
				cognito.getSession();
			} else {
				alert("process.env.VUE_APP_URL is undefined, can't redirect to proper login URI. \n \n Will redirect to Risolto homepage.");
				window.location.href = 'https://risolto.be';
			}

			NProgress.done();
		}
	}
});

router.afterEach(() => {
	// finish progress bar
	NProgress.done();
});
